import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Notification, useToaster } from "rsuite";
import Table from "rc-table";

import { Translation } from "react-i18next";
import { PartnerService } from "_services";
import i18n from "i18n";
import { Link } from "react-router-dom";

import { HiUserGroup, HiOutlineUserGroup } from "react-icons/hi2";
import RowTable from "components/Tables/RowTable";
import { RootService } from "_services/root.service";
import UserTable from "components/Tables/UserTable";

const columns = [
  {
    title: "UserID",
    dataIndex: "UserID",
    className: "",
    key: "UserID",
    width: 80,
  },
  {
    id: "UserName",
    title: "UserName",
    dataIndex: "UserName",
    className: "b",
    key: "UserName",
    width: 200,
  },

  {
    title: "Operations",
    dataIndex: "",
    className: "text-right",
    key: "d",
    render() {
      return <a href="#">Operations</a>;
    },
  },
];

export const Users = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = useState([]);
  const toaster = useToaster();
  const message = (msg, type) => {
    return <Notification type={type} header={msg} closable></Notification>;
  };

  useEffect(() => {
    getListData();
  }, []);

  const getListData = async () => {
    setLoading(true);
    await RootService.GET_FINANCIAL_CASH()
      .then((res) => {
        debugger;
        setLoading(false);
        setData(res.dynamicValue.Result.ChildDetails);
      })
      .catch((err) => {
        setLoading(false);
        debugger;
        if (err) {
          toaster.push(message(i18n.t("MESSAGE_CREATE_GAMER_FAILD"), "error"), {
            duration: 2000,
          });
        } else {
          toaster.push(message(i18n.t("MESSAGE_CREATE_GAMER_FAILD"), "error"), {
            duration: 2000,
          });
        }
      });
  };

  const onExpand = (expanded, record) => {
    // eslint-disable-next-line no-console
    //console.log("onExpand", expanded, record);
  };

  function CustomExpandIcon(props) {
    return (
      <div
        className={`btn btn-primary text-white ${
          props.expanded ? "" : "btn-outline"
        } btn-sm btn-square`}
        onClick={(e) => {
          props.onExpand(props.record, e);
        }}
        // eslint-disable-next-line react/no-danger
      >
        {props.expanded ? <HiOutlineUserGroup /> : <HiUserGroup />}
      </div>
    );
  }

  return (
    <Translation>
      {(t) => (
        <div>
          <div className="border-b py-3 border-primary-500 mb-5 shadow-xl flex justify-between">
            <label className="text-lg text-white">{t("MENU_ITEM_USERS")}</label>
            <div>
              {props.user && props.user.RelUserType.TypeID > 1 && (
                <Link
                  className="btn btn-primary btn-xs hover:text-primary-700 text-white"
                  to="/create"
                >
                  {t(
                    `${
                      props.user.RelUserType.TypeID == 1
                        ? "MENU_ITEM_CREATE_SAGAMER"
                        : props.user.RelUserType.TypeID == 2
                        ? "MENU_ITEM_CREATE_ADMIN"
                        : props.user.RelUserType.TypeID == 3
                        ? "MENU_ITEM_CREATE_PARTNER"
                        : props.user.RelUserType.TypeID == 4
                        ? "MENU_ITEM_CREATE_GAMER"
                        : ""
                    }`
                  )}
                </Link>
              )}
            </div>
          </div>
          <div>
            <UserTable data={data} />
          </div>
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn } = authentication;

  return {
    user,
    loggedIn,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
